module.exports = __webpack_public_path__ + "static/media/img_32.74742b78.JPG";